<template>
    <div class="page">
        <Headers></Headers>
        <div class="banner">
            <!-- 顶部标题 -->
            <div class="pdfPageTitle mg_t">
                <div class="pdfPageTitle-txt">
                    <span class="pdfPageTitle-txt__first" style="font-size:42px">Contribution to Direct Emission Reduction </span>
                    <span class="pdfPageTitle-txt__second" style="font-size:26px">({{PdftStore.fromData.spaceEmissionDirectReduction?.weight}}% weight)</span>
                </div>
                <div class="pdfPageTitle-icon">
                    <img src="@/assets/img/page7.png">
                </div>
            </div>

            <!-- 顶部数据 -->
            <div class="top_box">
                <div class="left">
                    <div class="title mg_b">Emission data: </div>
                    <div class="txt">{{PdftStore.fromData.spaceEmissionDirectReduction?.emissionDataStr}}</div>
                    <!-- <div class="tx">Data source: Pages xx, Report xx </div> -->
                </div>
                <div class="right">
                    <div class="title">Data and Reference Standard </div>
                    <div class="h4txt">{{PdftStore.fromData.spaceEmissionDirectReduction?.referenceStandards}}</div>
                </div>
            </div>

            <!-- 明细 -->
            <div class="min_box">
                <div class="title">Detailed Scoring of the Carbon Neutral Operation Index </div>
                <List :type=3  :id="'listPdfReport3'"/>
            </div>

            <!-- 数据图表 -->
            <div class="banner_box">
                <div class="left_box">
                    <div class="title">Score for Direct Emission Reduction</div>
                    <div class="jindu" v-if="PdftStore.fromData.spaceEmissionDirectReduction">
                        <Progess :name="'page7progess'" :num="PdftStore.fromData.spaceEmissionDirectReduction?.updateScore" :maxNum="'0ten thousand'" :minNum="'45ten thousand'" :carbonNum="PdftStore.fromData.spaceEmissionDirectReduction?.emissionDataStr+''" :max='100' :min='30'/>
                    </div>
                </div>
                <div class="right_box">
                    <div class="top_box_banner">
                        <div class="title">Score and Scoring Criterion</div>
                        <div class="h4txt">{{PdftStore.fromData.spaceEmissionDirectReduction?.scoreStandard}}</div>
                    </div>
                    <div class="title">Summary Performance of the Carbon Neutral Operation Index </div>
                    <div class="ec_t" v-if="PdftStore.fromData.spaceEmissionDirectReduction">
                        <Echarts :name="'page7echarts'"  :type="'c'"/>
                    </div>
                </div>
            </div>
            <!-- 底部 -->
            <Bottoms/>
            <div class="flxed">05</div>
        </div>
    </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import Headers from '../components/headers.vue'
import Bottoms from '../components/bottoms.vue'
import Progess from '../components/progess.vue'
import List from '../components/list.vue'
import Echarts from '../components/echarts.vue'
import { usePdftStore } from '@/store/pdf'
import { formatDateTimeYYmm, formatDateTimeYY } from '@/utils/date'
export default {
    name: 'page7',
    components:{Headers, Bottoms, List, Progess, Echarts},
    setup() {
        const data = reactive({})
        //引入数据管理库
        const PdftStore = usePdftStore()
        const formatDateTimeYYmms = (str) => {
            return formatDateTimeYYmm(str)
        }
        const formatDateTimeYYs = (str) => {
            return formatDateTimeYY(str)
        }
        onBeforeMount(() => {})
        onMounted(() => {})
        return {
            PdftStore,
            formatDateTimeYYmms,
            formatDateTimeYYs,
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.page{
    width: 1512px;
    height: 2149px;
    margin: 0 auto;
    background: #FFFFFF;
    position: relative;
    .banner{
        width: 100%;
        padding: 0 130px;
        .mg_t{
            margin-top: 96px;
        }
        .flxed{
            position: absolute;
            right: 20px;
            bottom: 20px;
            font-size: 24px;
            font-weight: 400;
            color: #333333;
            line-height: 33px;
        }
        .top_box{
            margin-top: 50px;
            max-height: 200px;
            display: flex;
            .title{
                font-size: 28px;
                font-weight: 500;
                color: #333333;
                line-height: 42px;
            }
            .left{
                width: 710px;
                .mg_b{
                    margin-bottom: 20px;
                }
                .txt{
                    font-size: 32px;
                    font-weight: 500;
                    line-height: 53px;
                    color: rgba(0, 186, 244, 1);
                }
                .tx{
                    margin-top: 15px;
                    font-size: 18px;
                    font-weight: 400;
                    color: #666666;
                }
            }
            .right{
                width: calc(100% - 710px);
                padding-left: 40px;
                border-left: 1px solid #C5C5C6;
                .txt{
                    font-size: 20px;
                    font-weight: 400;
                    color: #333333;
                    line-height: 42px;
                    margin-top: 23px;
                }
            }
            
        }
        .min_box{
            margin-top: 55px;
            font-size: 24px;
            font-weight: 500;
            color: #333333;
            line-height: 42px;
            .title{
                margin-bottom: 33px;
            }
        }
    }
}
.banner_box{
    display: flex;
    width: 100%;
    margin-top: 70px;
    .left_box{
        width: 670px;
        height: 100%;
        padding-right: 40px;
        
    }
    .right_box{
        width: calc(100% - 670px);
        height: 100%;
        padding-left: 39px;
        border-left: 1px solid #C5C5C6;
    }
    .top_box_banner{
        height: 350px;
    }
    .title{
        font-size: 28px;
        font-weight: 500;
        color: #333333;
        line-height: 42px;
    }
    .jindu{
        height: calc(880px - 42px);
        width: 100%;
        display: flex;
        align-items: center;
    }
    .mg_top{
        margin-top: 90px;
    }
    .ec_t{
        margin-top: 40px;
        width: 100%;
        height: 413px;
    }
    .txt{
        font-size: 20px;
        font-weight: 400;
        color: #333333;
        line-height: 42px;
        margin-top: 40px;
    }
    .txt_s{
        color: #999999;
    }
}
</style>